export default __webpack_public_path__ + "static/media/franklin-gothic-medium.70fe5201.ttf";